<div class="sync-confirm-infos">
  <h1 class="sync-confirm-title">{{'sync-confirm-dialog.synchro' | translate}}</h1>
  <p class="sync-confirm-text">{{'sync-confirm-dialog.message' | translate}}</p>
</div>
<div class="sync-confirm-buttons">
  <button matRipple class="sync-confirm-button" (click)="closeDialog()">{{'sync-confirm-dialog.cancel' | translate}}</button>
  <button matRipple class="sync-confirm-button" (click)="onSyncConfirmation()">{{'sync-confirm-dialog.confirm' | translate}}</button>
</div>
